// src/components/Footer.jsx
import { Link } from "react-router-dom";

function SocialIcon({ title, children, href = "#" }) {
  return (
    <a
      href={href}
      aria-label={title}
      className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-white/5 text-white/80 hover:bg-white/10 hover:text-white transition"
    >
      {children}
    </a>
  );
}

export default function Footer() {
  const legalLinks = [
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Terms & Conditions", to: "/terms" },
    { label: "Partners", to: "/partners" },
    { label: "CA Residents Only - Do not sell my info", to: "/do-not-sell" },
    { label: "California Privacy", to: "/california-privacy" },
    { label: "Unsubscribe", to: "/unsubscribe" },
  ];

  return (
    <footer className="bg-slate-950 text-white/85">
      {/* Reduced vertical padding */}
      <div className="max-w-6xl mx-auto px-4 py-8 md:py-10">
        {/* Top: 4 columns, top aligned */}
        <div className="grid lg:grid-cols-[1.25fr,0.85fr,1fr,1fr] items-start gap-8">
          {/* Brand + headline */}
          <div className="self-start">
            <div className="flex items-center gap-2 text-white">
              <span className="text-[#C89B3C] text-xl">⚖</span>
              <span className="text-lg font-semibold">MassTortPlaintiffs</span>
            </div>
            <p className="mt-2 text-sm text-white/70 leading-relaxed">
              Nationwide network connecting injured consumers with vetted
              mass-tort law firms. No upfront fees — you pay only if you win.
            </p>
          </div>

          {/* Social */}
          <div className="self-start">
            <h6 className="text-white font-semibold">Social</h6>
            <div className="mt-2 flex items-center gap-3">
              <SocialIcon title="Facebook">
                <svg
                  viewBox="0 0 24 24"
                  className="h-5 w-5"
                  fill="currentColor"
                >
                  <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 4.99 3.66 9.13 8.44 9.94v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.25 0-1.64.78-1.64 1.58v1.9h2.79l-.45 2.9h-2.34V22c4.78-.81 8.44-4.95 8.44-9.94Z" />
                </svg>
              </SocialIcon>
              <SocialIcon title="X">
                <svg
                  viewBox="0 0 24 24"
                  className="h-5 w-5"
                  fill="currentColor"
                >
                  <path d="M18.36 2H21l-6.9 7.89L22 22h-6.83l-5.34-6.98L3.6 22H1l7.4-8.46L2 2h6.91l4.79 6.42L18.36 2Zm-2.39 18h1.87L8.11 4H6.18l9.79 16Z" />
                </svg>
              </SocialIcon>
              <SocialIcon title="LinkedIn">
                <svg
                  viewBox="0 0 24 24"
                  className="h-5 w-5"
                  fill="currentColor"
                >
                  <path d="M6.94 8.79H3.9V21h3.04V8.79ZM5.42 3a1.76 1.76 0 1 0 0 3.52 1.76 1.76 0 0 0 0-3.52ZM20.1 21h-3.03v-6.6c0-1.57-.03-3.6-2.19-3.6-2.2 0-2.53 1.72-2.53 3.5V21H9.33V8.79h2.9v1.67h.04c.4-.76 1.37-1.56 2.83-1.56 3.03 0 3.59 1.99 3.59 4.59V21Z" />
                </svg>
              </SocialIcon>
              <SocialIcon title="Instagram">
                <svg
                  viewBox="0 0 24 24"
                  className="h-5 w-5"
                  fill="currentColor"
                >
                  <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-5 3.9a5.1 5.1 0 1 1 0 10.2 5.1 5.1 0 0 1 0-10.2Zm0 2a3.1 3.1 0 1 0 0 6.2 3.1 3.1 0 0 0 0-6.2Zm5.35-.95a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1Z" />
                </svg>
              </SocialIcon>
            </div>
          </div>

          {/* Sitemap A */}
          <div className="self-start">
            <h6 className="text-white font-semibold">Sitemap</h6>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="#active-lawsuits" className="hover:text-white">
                  Active Lawsuits
                </a>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-white">
                  Class Actions FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Sitemap B */}
          <div className="self-start">
            <h6 className="text-white font-semibold">Sitemap</h6>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="#" className="hover:text-white">
                  Open Settlements
                </a>
              </li>
              <li>
                <Link to="/about" className="hover:text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white">
                  Recent News
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Slimmer divider */}
        <hr className="mt-8 border-white/10" />

        {/* Bottom: centered + tighter spacing */}
        <div className="mt-5 flex flex-col items-center text-center gap-2.5">
          <div className="text-sm text-white/70">
            {legalLinks.map((l, i) => (
              <span key={l.label}>
                <Link to={l.to} className="hover:text-white">
                  {l.label}
                </Link>
                {i !== legalLinks.length - 1 && (
                  <span className="mx-3 text-white/25">|</span>
                )}
              </span>
            ))}
          </div>

          <p className="text-xs text-white/60">
            Attorney advertising. Past results do not guarantee future outcomes.
            Submitting information does not create an attorney–client
            relationship.
          </p>

          <p className="text-xs text-white/60">
            © {new Date().getFullYear()} MassTortPlaintiffs. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
